module.exports = __webpack_public_path__ + "img/bj.e21db857.png";